/**
 * MKS-540 — the organizer's per-person guest limit, as the create and edit
 * forms handle it.
 *
 * It lives in `utils/` rather than next to the API module so a page suite that
 * mocks `services/api/teamEvents` keeps it.
 */
import { MAX_EVENT_GUESTS } from '../services/api/teamEvents';

/**
 * Keep a typed limit inside 1..MAX_EVENT_GUESTS. A cleared number input reads
 * as NaN, which becomes 1 — the field is never allowed to submit "no limit".
 */
export function clampMaxGuestsPerPerson(next: number): number {
  if (!Number.isFinite(next)) return 1;
  return Math.min(Math.max(Math.trunc(next), 1), MAX_EVENT_GUESTS);
}

/**
 * How many 'going' participants already bring more guests than the limit the
 * organizer is looking at. Lowering a limit never trims anyone, so the detail
 * page says how many people are above it.
 */
export function countOverLimitParticipants(
  participants: { noShow: boolean; guestCount: number }[],
  limit: number,
): number {
  return participants.filter((p) => !p.noShow && p.guestCount > limit).length;
}
